import type { CustomFieldSchema } from '@tribeplatform/gql-client/types'
import {
  useListFilters,
  type ListFilter,
  type RawFilter,
} from '@tribeplatform/react-components/Filters'
import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { IndicatorBadge } from '@tribeplatform/react-ui-kit/IndicatorBadge'

interface Props {
  customFields: CustomFieldSchema[]
  entityFilters: ListFilter[]
  staticFilters: RawFilter[]
  disabled?: boolean
  onClick: () => void
}
export const AddFilterButton = ({
  customFields,
  entityFilters,
  staticFilters,
  disabled,
  onClick,
}: Props) => {
  const { filters } = useListFilters({
    entityListFilters: entityFilters,
    customFields,
    staticFilters,
  })

  return (
    <Button
      variant="secondaryNeutral"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      leadingIcon={
        filters.length > 0 ? (
          <IndicatorBadge variant="primary" count={filters.length} />
        ) : (
          <SvgIcon name="plus" />
        )
      }
      className={filters?.length && 'text-interactive'}
    >
      {filters.length > 0 ? (
        <T
          defaultMessage="{filter_count, plural, one {Active filter} other {Active filters}}"
          id="ViewSettings.Filters.ActiveFilters"
          values={{
            filter_count: filters.length,
          }}
        />
      ) : (
        <T defaultMessage="Add filter" id="Generics.AddFilter" />
      )}
    </Button>
  )
}
